export default __webpack_public_path__ + "static/KeywordResearch_01_01@2x-5a9d81f59b37a790aef70e8a5b64884f.png";